module.exports = __webpack_public_path__ + "img/recurrent_customers.50383b88.svg";